// Felles UI-tekst: layout, footer, navigasjon, kort, datoer, feil.
export const NN_COMMON = {
  "Språkvalg": "Språkval",
  "Laster...": "Lastar …",
  "Laster…": "Lastar …",
  "Noe gikk galt. Prøv igjen.": "Noko gjekk gale. Prøv igjen.",
  "Gratis": "Gratis",
  "Gratis – {max} kr": "Gratis – {max} kr",
  "Fra {min} kr": "Frå {min} kr",
  "{min} kr": "{min} kr",
  "kl.": "kl.",

  // Kategorier (visningsnavn – lagret verdi er uendret)
  "Konsert": "Konsert",
  "Teater": "Teater",
  "Sport": "Sport",
  "Festival": "Festival",
  "Foredrag": "Foredrag",
  "Annet": "Anna",

  // PublicLayout
  "Ikke gebyrpåslag": "Ikkje gebyrpåslag",
  "QR-kode innsjekk": "QR-kode-innsjekk",
  "Ingen log-in nødvendig": "Ingen innlogging nødvendig",
  "Er du arrangør?": "Er du arrangør?",
  "Logg inn": "Logg inn",
  "eller": "eller",
  "bli arrangør": "bli arrangør",
  "Dashbord": "Dashbord",
  "Arrangør": "Arrangør",
  "Bli arrangør": "Bli arrangør",
  "rightin.no — Ikke gebyrpåslag – QR-innsjekk inkludert.": "rightin.no — Ikkje gebyrpåslag – QR-innsjekk inkludert.",
  "For arrangører": "For arrangørar",
  "Pris": "Pris",
  "Hva er nytt": "Kva er nytt",
  "Nyhetsbrev": "Nyheitsbrev",
  "Vilkår for kjøp": "Vilkår for kjøp",
  "Personvern og GDPR": "Personvern og GDPR",
  "Alle rettigheter forbeholdt": "Alle rettar reserverte",
  "Personvernerklæring (GDPR)": "Personvernerklæring (GDPR)",

  // EventCard
  "Utsolgt": "Utselt",
  "Sted kommer": "Stad kjem",
  "Ingen ledige plasser": "Ingen ledige plassar",
  "{n} ledige plasser": "{n} ledige plassar",
  "1 ledig plass": "1 ledig plass",
  "Ca. {km} km unna": "Ca. {km} km unna",

  // DashboardLayout
  "Oversikt": "Oversikt",
  "Se offentlig side": "Sjå offentleg side",
  "Offentlig side": "Offentleg side",
  "Team": "Team",
  "Betaling": "Betaling",
  "Hjelp (F1)": "Hjelp (F1)",
  "Hjelp (F1) – veiledning for arrangører (PDF)": "Hjelp (F1) – rettleiing for arrangørar (PDF)",
  "Hjelp – veiledning (PDF)": "Hjelp – rettleiing (PDF)",
  "Opprett arrangement": "Opprett arrangement",
  "Logg ut": "Logg ut",
  "Bytt organisasjon": "Byt organisasjon",
  "Org.nr {n}": "Org.nr {n}",
  "Godkjenninger": "Godkjenningar",
  "Fakturaer (admin)": "Fakturaer (admin)",
  "Arrangementer (admin)": "Arrangement (admin)",
  "E-postbekreftelse (admin)": "E-poststadfesting (admin)",
  "Kontaktregister (admin)": "Kontaktregister (admin)",
  "Vipps (admin)": "Vipps (admin)",
  "Svar (admin)": "Svar (admin)",
  "Svar-sporing OK": "Svar-sporing OK",
  "Svar-sporing har problemer: {list}": "Svar-sporing har problem: {list}",
  "Bilderydding (admin)": "Biletrydding (admin)",
  "Legg til organisasjon": "Legg til organisasjon",
  "{n} ubrukte bilder slettet": "{n} ubrukte bilete sletta",
  "Kunne ikke rydde bilder": "Kunne ikkje rydde bilete",
  "Byttet til {name}": "Bytte til {name}",
  "Kunne ikke bytte organisasjon": "Kunne ikkje byte organisasjon",
  "Slette {n} ubrukte bilder?": "Slette {n} ubrukte bilete?",
  "Dette fjerner permanent alle bilder som ikke er i bruk av noe arrangement. Bilder som er i bruk, påvirkes ikke. Handlingen kan ikke angres.":
    "Dette fjernar permanent alle bilete som ikkje er i bruk av noko arrangement. Bilete som er i bruk, vert ikkje påverka. Handlinga kan ikkje angrast.",
  "Avbryt": "Avbryt",
  "Slett ubrukte bilder": "Slett ubrukte bilete",

  // ── Postnummerfelt (inkrementelt søk i Postnummerregisteret) ──
  "5463 eller Uskedalen": "5463 eller Uskedalen",
  "Postnummer-forslag": "Postnummer-forslag",
  "postboks": "postboks",
  "Ukjent postnummer": "Ukjent postnummer",
  // ── Adressefelt (forslag frå Kartverket/Geonorge) ──
  "F.eks. Skålagato 1": "T.d. Skålagato 1",
  "Adresseforslag": "Adresseforslag",
  "Kilde: Kartverket": "Kjelde: Kartverket",
  "Adresseforslag er utilgjengelig akkurat nå – skriv adressen manuelt.": "Adresseforslag er utilgjengeleg akkurat no – skriv adressa manuelt.",
  "Adressesøket (Kartverket) svarer ikke akkurat nå – skriv adressen manuelt": "Adressesøket (Kartverket) svarar ikkje akkurat no – skriv adressa manuelt",
};
